export default {
  common: {
    email: 'E-posta',
    phone: 'Telefon',
    phoneNumber: 'Telefon Numarası',
    countrySelect: 'Ülkeyi seçin',
    countryUnmodifiedNote: 'Ülke kayıttan sonra değiştirilemez',
    next: 'Sonraki',
    back: 'Geri',
    attention: 'Dikkat',
    cancel: 'İptal',
    confirm: 'Onayla',
    modify: 'Değiştir',
    ignore: 'Yoksay',
    firstName: 'Ad',
    middleName: 'Orta Ad',
    lastName: 'Soyad',
    gender: 'Cinsiyet',
    male: 'Erkek',
    female: 'Kadın',
    birthday: 'Doğum Günü',
    graphicCode: 'Grafik Kodu',
    emailCode: 'E-posta Doğrulama Kodu',
    smsCode: 'SMS Kodu',
    smsVerificationCode: 'SMS doğrulama kodu',
    bind: 'Bağla',
    send: 'Gönder',
    resend: 'Tekrar Gönder',
    address: 'Adres',
    done: 'Tamamlandı',
    systemMessage: 'Sistem Mesajı',
    setting: 'Ayar',
    submit: 'Gönder',
    language: 'Diller',
    edit: 'Düzenle',
    delete: 'Sil'
  },
  account: {
    account: 'Hesap',
    nickname: 'Takma ad',
    id: 'Kimlik',
    basicInfo: 'Temel Seviye',
    placeholder: 'Lütfen girin',
    completed: 'Tamamlandı',
    semiInfo: 'Yarı Doğrulanmış',
    fullyInfo: 'Tam Doğrulanmış',
    basicTab: 'Temel',
    advancedTab: 'Gelişmiş',
    linkedAccount: 'Bağlantılı Para Çekme Hesabı',
    accountSecurity: 'MetWallet Hesabı ve Güvenlik',
    logout: 'Çıkış Yap',
    semiToast: 'Lütfen Temel Seviye doğrulamasını tamamlayın',
    fullyToast: "Lütfen Temel Seviye \n ve Yarı Doğrulanmış'ı tamamlayın",
    quickLoginTitle: 'Hızlı Giriş',
    cancelQuickLogin: 'Hızlı Girişi devre dışı bırakmak istediğinizden emin misiniz?'
  },
  accountSecurity: {
    title: 'Hesap ve Güvenlik',
    payPwd: 'Ödeme Parolası',
    loginPwd: 'Giriş Parolası',
    changeEmail: 'E-postayı Değiştir',
    changePhone: 'Telefon Numarasını Değiştir',
    changePayPwd: 'Ödeme Parolasını Değiştir',
    changeLoginPwd: 'Giriş Parolasını Değiştir',
    bindEmail: 'E-postayı Bağla',
    bindEmailNote: 'Bağlamak için E-posta doğrulamasını geçin',
    bindEmailPlaceholder: 'Bağlamak istediğiniz E-postayı girin',
    smsBindNote: 'Bağlamak için SMS doğrulamasını geçin',
    bindPhone: 'Telefon Numarasını Bağla',
    smsAuthentication: 'SMS Kimlik Doğrulaması',
    emailAuthentication: 'E-posta Kimlik Doğrulaması',
    phoneVerificationNote: 'Önce geçerli telefon numarası doğrulamasını geçin',
    bindPhonePlaceholder: 'Bağlamak istediğiniz telefon numarasını girin',
    verificationWrongToast: 'Lütfen doğrulama kodunuzu kontrol edin',
    phoneNumberEmptyToast: 'Lütfen telefon numarasını girin',
    verificationCodeEmptyToast: 'Lütfen kodu girin',
    wrongCodeToast: 'Yanlış kod',
    changeNote: 'Lütfen değiştirmek için doğrulamayı geçin.',
    newEmailVerification: 'Yeni E-posta Doğrulaması',
    newEmailPlaceholder: 'Yeni E-postanızı girin',
    change: 'Değiştir',
    emailLowercaseToast: 'E-posta küçük harflerle yazılmalıdır.',
    newEmailEmptyToast: 'Lütfen yeni e-postayı doldurun',
    changeSuccessToast: 'Başarıyla değiştirin',
    phonePlaceholder: 'Telefonu girin',
    currentEmail: 'Geçerli E-posta',
    passCurrentEmailVerificationFirst: 'Önce geçerli E-posta doğrulamasını geç',
    currentEmailVerification: 'Geçerli E-posta Doğrulaması',
    smsVerification: 'SMS Doğrulaması',
    currentPhoneNumber: 'Mevcut Telefon Numarası',
    currentPhoneVerification: 'Mevcut Telefon Doğrulaması',
    currentEmailAddress: 'Mevcut E-posta Adresi',
    phoneVerification: 'Telefon Doğrulaması',
    enterVerificationCode: 'หมายเลขโทรศัพท์ใหม่',
    newPhoneNumber: 'Yeni telefon numarası',
    newEmail: 'Yeni E-posta'
  },
  withdrawAccount: {
    selectAccountType: 'Hesap Türünü Seç',
    noBasicLevelVerificationDialog:
      'Nakit çekme yöntemini bağlamadan önce lütfen Temel Seviye doğrulamasını tamamlayın.',
    bindNote: 'Lütfen doğru hesap bilgilerini girin, aksi takdirde para çekme işleminiz etkilenir.',
    bindBankAccount: 'Banka Hesabını Bağla',
    bindMobileMoneyAccount: 'Mobil Para Hesabını Bağla',
    fieldEmptyToast: '{0} gereklidir',
    fieldLengthToast: '{0} en az {1} karakter içermelidir',
    bindBankRepeatToast: 'Aynı banka hesabını tekrar tekrar bağlamayın!',
    accountName: 'Hesap Adı',
    ifscCode: 'IFSC Kodu',
    accountEmptyToast: 'Hesap gereklidir',
    accountNameEmptyToast: 'Hesap Adı gereklidir',
    phoneEmptyToast: 'Telefon gereklidir',
    emailEmptyToast: 'E-posta gereklidir',
    ifscCodeEmptyToast: 'IFSC Kodu gereklidir',
    ifscCodeLengthToast: 'IFSC Kodu 11 haneli olmalıdır',
    bindIMPSRepeatToast: 'Aynı IMPS hesabını tekrar tekrar bağlamayın!',
    bindNote2:
      'Lütfen doğru TRC-20 adresinizi girin. Yanlış adres ödemenin kaybolmasına neden olur ve bu konuda hiçbir sorumluluk kabul etmiyoruz.',
    usdtAddress: 'USDT adresi (TRC-20):',
    minimumLimit: 'İşlem başına minimum para çekme tutarı: 10 $',
    usdtFee: 'Ücret: Gerçek ücrete tabidir',
    registerGcash: 'Gcash hesabınız yoksa lütfen kaydolmak için buraya tıklayın.',
    registerEpay: 'Epay hesabınız yoksa lütfen kaydolmak için buraya tıklayın.',
    bindThirdPartyTitle: 'Bağla {0} Hesabı',
    wrongAccountToast: 'Yanlış hesap',
    accountFormatToast: 'Hesap biçimi yanlış',
    bindThirdPartyFailedToast: '{0} bağlama başarısız',
    queryFailedToast: 'Sorgu Başarısız Oldu.',
    editFailedToast: 'Düzenleme Başarısız Oldu.',
    add: 'Ekle',
    confirmEditDialog: 'Hesabı düzenlemek istediğinizden emin misiniz {0}?',
    payPwdRequireDialog: 'Lütfen bir hesap eklemeden önce 6 haneli bir ödeme şifresi belirleyin.',
    unbindFailedToast: 'Bağlayıcıyı kaldırma başarısız oldu',
    cashOutSuccessNote: 'Tahmini varış saati：7 iş günü içinde',
    requestSubmitted: 'Para çekme talebi gönderildi',
    amountLimitToast1: 'Nakit çıkış tutarı ≥$40,00 olmalıdır',
    // eslint-disable-next-line no-template-curly-in-string
    amountLimitToast2: 'Nakit çıkış tutarı ≥${0},00 olmalıdır',
    recommendAmountNote:
      // eslint-disable-next-line no-template-curly-in-string
      "İpuçları: Para çekmeden önce tutarı ${0}'a biriktirmek, işlem ücretlerinizi etkili bir şekilde kurtaracaktır.",
    amountNotEnoughToast: 'Nakit çıkış tutarı yeterli değil',
    exceedingLimitToast1: 'Bugünkü nakit çıkış tutarı üst sınıra ulaştı',
    exceedingLimitToast2:
      'Bugünkü nakit çıkış tutarı üst sınıra ulaştı. Sınırı yükseltmek için gelişmiş sertifikayı tamamlamanız gerekiyor mu?',
    restrictedCountriesPayPalAccountToast:
      "Arripay'inizin bloke olmasına neden olacak kısıtlı ülkelerdeki PayPal hesabını kullanmayın",
    withdrawMinimumToast: 'İşlem başına minimum çekim:$40',
    bankNotAvailableToast:
      'Bu banka artık kullanılamıyor, lütfen diğer bankaları bağlayın. Bu USDT hesabı para çekemiyor, lütfen para çekmek için yeni bir hesap kullanın.',
    usdtAccountInvalidToast: 'Lütfen para çekmeden önce 6 haneli bir ödeme şifresi belirleyin.',
    noPayPwdToast: '',
    editBankAccount: 'Banka Hesabını Düzenle',
    accountPlaceholder: 'Hesabınızı girin',
    trc20Placeholder: 'TRC-20 adresini girin',
    accountRepeatToast: 'Mevcut olanla aynı.',
    unbindBankCardConfirmDialog: 'Banka kartınızı {0} açmak istediğinizden emin misiniz?',
    unbindMobileMoneyAccountConfirmDialog: 'Mobil para hesabınızı {0} açmak istediğinizden emin misiniz?',
    unbindAccountConfirmDialog: 'Hesabınızı {0} açmak istediğinizden emin misiniz?',
    availableBalance: 'Kullanılabilir bakiye {0}',
    estimatedFee: 'Tahmini ücret',
    submitFailToast: 'Gönderme başarısız oldu',
    disabledMethodToast: 'Bu kanal geçici olarak kullanılamıyor',
    channelUnavailableTitle: 'Kanal kullanılamıyor',
    channelUnavailableNote: 'Bu para çekme kanalı geçici olarak kullanılamıyor. Lütfen başka bir yol deneyin.',
    channelUnavailableOk: 'Tamam',
    bankTransferUnavailableTitle: 'Banka havalesi kullanılamıyor',
    bankTransferUnavailableNote:
      'Banka havalesi hesabınız için şu anda kullanılamıyor. Lütfen para çekmek için Epay kullanın.',
    channelMaintenanceTitle: 'Kanal bakımda',
    channelMaintenanceNote: 'Bu para çekme kanalı bakımda. Lütfen başka bir yol deneyin.',
    bankInfoUpdateTitle: 'Banka bilgilerinizi güncelleyin',
    bankInfoUpdateNote: 'Banka politika değişikliği nedeniyle devam etmek için lütfen banka bilgilerinizi güncelleyin.',
    bindEpay: 'Epay bağla',
    useEpay: 'Epay kullan',
    iMPSMaxLimitToast: "Bu kanal üzerinden tek bir işlem için çekilebilecek maksimum tutar 260$'dır.",
    linkedAccount: 'Hesap eklendi',
    otherAccounts: 'Diğer hesaplar eklenebilir',
    withdrawTo: 'Transfer',
    withdrawAmount: 'Transfer tutarı',
    withdrawable: 'Çekilebilir',
    documentIdToast: 'Kimlik Numarası yalnızca sayılar içerebilir',
    noAvailableMethodNote: 'Kullanılabilir bir çekim yöntemi yok',
    recommended: 'Önerilen'
  },
  paymentCode: {
    changePayPwd: 'Ödeme Parolasını Değiştir',
    setPayPwd: 'Ödeme Şifresini Ayarla',
    setPayPwdNote: 'Lütfen 6 haneli ödeme şifresini ayarlayın',
    reenterPayPwdNote: 'Tekrar girin',
    verificationNote: 'Ayarlamak için lütfen doğrulamayı geçin.',
    emailVerification: 'E-posta Doğrulaması',
    inconsistentPasswordToast: 'Tutarlı olmayan şifre',
    payPwdNote: 'Lütfen ödeme şifresini girin',
    payPwdFormatToast: 'Ödeme şifresi 6 haneli bir sayıdır',
    payPwdWrongToast: 'Yanlış ödeme şifresi',
    payPwdVerificationFailToast: 'Ödeme şifresi doğrulaması başarısız oldu!',
    successToast: '\n başarıyla ayarlayın'
  },
  authorize: {
    requirement:
      "{0}, sizin için ilgili hizmeti sağlamak üzere MetWallet{1}'inizin aşağıdaki bilgilerini edinmelidir. Takma ad, Avatar, Cinsiyet vb.",
    authorize: 'Yetkilendir',
    switchAccount: 'Hesabı Değiştir',
    goToMetWallet: "MetWallet'a Git",
    notMatchTips: 'İşlem başarısız oldu. Hızlı Girişi yalnızca bağlı MetWallet hesabınızla etkinleştirebilirsiniz.'
  },
  basicLevel: {
    namePlaceholder: 'Sembol, sayı yok',
    verification: 'Doğrulama',
    whatsAvailable: 'Neler mevcut',
    cashOut: 'Nakit Çekme',
    withdrawLimit: 'Günlük 50$',
    basicLevelNote:
      'Lütfen gerçek kişisel bilgilerinizi girin. Yanlış bilgi, para çekme işleminin başarısız olmasına neden olabilir.',
    fieldEmptyToast: 'Lütfen tüm gerekli alanları doldurun.',
    successToast: 'Başarıyla kaydedildi',
    failToast: 'Kaydedilemedi',
    confirmDialog:
      'Gerçek kişisel bilgilerinizi girdiğinizden emin olun. Yanlış bilgi, para çekme işleminin başarısız olmasına neden olabilir.',
    birthdayFormatToast: 'Yanlış Doğum Günü alanı biçimi',
    verificationCodeError: 'Doğrulama kodu hatası',
    verificationCodeEmpty: 'Doğrulama kodu boş',
    noEmailCodeToast: 'Lütfen e-posta doğrulama kodunu alın',
    checkDialogTitle: 'Bilgilerinizi Kontrol Edin',
    checkDialogContent:
      'Para çekme işleminin başarılı olması için lütfen bilgilerinizi kontrol edin. Yanlış bilgi, para çekme işleminin başarısız olmasına neden olabilir.',
    check: 'Kontrol Et'
  },
  semiVerified: {
    uploadPhotoId: 'Fotoğraflı Kimlik Yükle',
    photoId: 'Fotoğraflı Kimlik',
    resubmit: 'Tekrar Gönder',
    limit: 'Günlük 5.000 ABD Doları',
    uploading: 'Yükleniyor...',
    notUploadProofToast: 'Lütfen bir kimlik kartı kanıtı yükleyin'
  },
  fullyVerified: {
    frontOfId: 'Kimlik ön yüzü',
    backOfId: 'Kimlik arka yüzü',
    uploadIdFront: 'Kimlik ön yüzünü yükle',
    uploadIdBack: 'Kimlik arka yüzünü yükle',
    withdrawDailyHint: 'Çekim için bilgileri doldurun > günde {0}.',
    notUploadIdToast: 'Lütfen kimliğin ön ve arka yüzünü yükleyin',
    proofTitle: 'İKAMET BELGESİ',
    acceptableProof: 'KABUL EDİLEBİLİR BİR İKAMET BELGESİ ŞUNLARDIR:',
    acceptableProof1: 'Banka hesap özeti.',
    acceptableProof2: 'Bir elektrik, su, internet vb. faturası.',
    acceptableProof3: 'Devlet tarafından verilmiş bir belge (vergi beyanı, ikamet belgesi vb.).',
    unacceptableProof: 'Gönderdiğiniz kimlik belgesindeki adresi geçerli bir ikamet kanıtı olarak kabul edemeyiz.',
    limit: 'Günlük 10.000 ABD Doları',
    notUploadToast: 'Lütfen ikamet kanıtı belgesi yükleyin',
    incorrectFormatToast: 'Lütfen jpg/png/jpeg resim yükleyin.'
  },
  loginAndRegister: {
    pwd: 'Şifre',
    lastLogin: 'Son Giriş',
    moreOptions: 'Daha Fazla Seçenek',
    agreeCheckboxContent: "{0} ve {1}'i kabul edin",
    userAgreement: 'Kullanıcı Sözleşmesi',
    privacyPolicy: 'Gizlilik Politikası',
    notAgreeToast: "Kullanıcı Sözleşmesi ve Gizlilik Politikası'nı kabul edin",
    forgotPassword: 'Şifremi Unuttum',
    linkedMail: 'Bağlantılı E-posta',
    verificationCode: 'Doğrulama Kodu',
    newPwd: 'Yeni Şifre',
    repeatPwd: 'Şifreyi Tekrarla',
    confirmPwd: 'Şifreyi onaylayın',
    noLinkedEmailToast: 'Hesabınıza bağlı E-posta yok',
    unregisteredToast: 'Bu numara kaydedilmedi',
    pwdFormatToast: 'Şifrenin biçimi yanlış',
    resetSuccessToast: 'Sıfırla \n başarıyla',
    pwdNotMatchToast: 'Şifreler iki kez eşleşmiyor',
    emailFormatToast: 'Yanlış E-posta Biçimi',
    phoneNumberFormatToast: 'Yanlış telefon numarası biçimi',
    invalidAreaCodeToast: 'Geçersiz alan kodu',
    login: 'Giriş yap',
    pwdLogin: 'Şifre ile giriş yap',
    emailCodeLogin: 'E-posta doğrulama kodu ile giriş yap',
    smsLogin: 'SMS ile giriş yap',
    verifyEmail: 'E-postayı doğrula',
    verifyPhone: 'Telefonu doğrula',
    accountDangerDialog:
      'Hesabınızda tehlike tespit edildi. Lütfen hesabınızı yeniden doğrulayın, aksi takdirde hesabınız kullanılmaya devam edemeyecek.',
    sendEmailCodeDialog: '{0} e-postanıza bir doğrulama kodu gönderdik. Lütfen doğrulama kodunu girin.',
    sendSmsCodeDialog: '{0} telefonunuza bir doğrulama kodu gönderdik. Lütfen doğrulama kodunu girin.',
    graphicCodeEmptyToast: 'Lütfen grafik kodunu girin.',
    countryUnselectToast: 'Lütfen önce ülkenizi seçin',
    unsupportedLoginTypeToast: 'Desteklenmeyen giriş türü',
    pwdWrongLimitOverDialog: '3 kez yanlış şifre girildi. Lütfen giriş yapmak için SMS doğrulama kodunu kullanın.',
    loginFailedToast: 'Giriş başarısız',
    signIn: 'Oturum aç',
    pwdPlaceholder: 'Şifreyi girin',
    pwdNote: '8-16 karakter girin (harf ve rakam içermeli)',
    reenterPwdPlaceholder: 'Şifreyi tekrar girin',
    reenterPwdNote: 'Lütfen şifreyi tekrar girin',
    createAccount: 'Hesap Oluştur',
    chooseCountryNote: 'Lütfen ülkeyi seçin',
    pwdInconsistentToast: 'Girdiğiniz önceki şifreyle aynı değil',
    createSuccessToast: '\n başarıyla oluşturuldu',
    registerFailToast: 'Kayıt başarısız oldu',
    userNotExistToast: 'Kullanıcı yok',
    phoneIncorrectToast: 'Lütfen telefonunuzu kontrol edin',
    userExistToast: 'Kullanıcı zaten var',
    countryCodeRepeatToast: 'Lütfen ülke kodunu tekrar tekrar girmeyin!',
    logoutDialog: 'Çıkış yapmak istediğinizden emin misiniz?',
    pwdRequirement: 'Şifre en az 8 ila 16 karakter uzunluğunda, harf ve sayılardan oluşmalıdır',
    signup: 'Kaydolun',
    registerSuccessToast: '\n başarıyla kaydolun',
    oldPwdErrorToast: 'Lütfen eski şifrenizi kontrol edin'
  },
  checkUserInfo: {
    title: 'Yönetim Merkezi',
    emptyInfoNote: 'Burada cari hesap için bilgi yok, lütfen doğrulamanız gereken MetWallet hesabını kontrol edin.',
    infoNote: 'İşte doğrulama bilgileriniz.',
    lastSuccessWithdrawal: 'Son başarılı çekim',
    copyBtn: 'Kopyala',
    successToast: 'Başarıyla kopyalandı!',
    failToast: 'Kopyalanamadı!'
  },
  country: {
    title: 'Bölge seçin',
    popular: 'Popüler'
  },
  documentDetails: {
    title: 'Belge Ayrıntıları',
    contract: 'Sözleşme',
    goToSign: 'İmzalamak için gidin',
    download: 'İndir',
    upload: 'Yükle',
    fileTypeLimit: 'doc., pdf., xlsx., xls., png., jpg., jpeg., yalnızca belgeler.',
    contentEmptyToast: 'Lütfen içeriği girin',
    placeOfBirth: 'Doğum yeri',
    occupation: 'Meslek',
    fileForm: '(Dosya Formu)',
    proofOfAddress: 'İngilizce Adres Kanıtı',
    residenceDoc: 'İkamet Belgesi',
    textForm: '(Metin Formu)',
    contractAgent: 'Sözleşme Temsilcisi',
    contractPayslip: 'Sözleşme Maaş Bordrosu',
    uncompletedToast: 'Göndermek için lütfen doldurun',
    successToast: 'Başarıyla Gönderildi',
    undefinedFileTypeToast: 'Tanımlanmamış dosya yükleme türü',
    uploadFailToast: 'Yükleme başarısız'
  },
  filters: {
    amount: 'Miktar',
    filter: 'Filtreler',
    time: 'Zaman',
    reset: 'Sıfırla',
    timePickerTitle: 'Seç {0} Zaman',
    start: 'Başlangıç',
    end: 'Bitiş',
    maximum: 'Azami',
    minimum: 'Asgari'
  },
  home: {
    balance: 'Bakiye',
    transactions: 'İşlemler',
    availableBalance: 'Kullanılabilir Bakiye',
    noWithdrawalMethodToast: 'En az bir çekim yöntemi gereklidir.',
    linkAccount: 'Hesabı Bağla',
    all: 'Tümü',
    cashIn: 'Nakit Para',
    loading: 'yükleniyor...',
    noMore: 'Başka işlem yok',
    reload: 'Yükleme başarısız, yeniden yüklemek için tıklayın',
    receivedFrom: 'Şuradan alındı',
    transferredTo: 'Şuraya aktarıldı',
    fee: 'Şuraya transfer ücreti',
    myEmail: 'E-postam',
    myPhone: 'Telefonum',
    invalidBasicLevelDialog:
      'Ad alanınızda semboller, boşluklar veya sayılar bulunduğu için hesaptan çekim yapmak mümkün değildir. Lütfen temel bilgileri tekrar doldurun (isim sembol, boşluk veya sayı içermediğinden emin olun ve aileniz veya ikinci adınız yoksa boş bırakın.)',
    lackLastNameDialog: 'Soyadınız doldurulmamış, bu da para çekme işleminizi engelleyecektir.',
    fillIn: 'Doldur',
    viewDetails: 'Ayrıntıları Görüntüle',
    docReviewingDialogTitle: 'Lütfen belgenin geçmesini bekleyin.',
    docReviewingDialogContent:
      "Belgeyi gönderdiniz, ancak belgeniz geçmeden MetWallet'ı kullanamazsınız.<br>Resmi personel yakında işleme koyacaktır, lütfen bir süre bekleyin.",
    docPassedDialog: "Gönderdiğiniz belge geçti. <br>MetWallet'ı artık normal şekilde kullanabilirsiniz.",
    docUnqualifiedDialog: 'Gönderdiğiniz belge niteliksizdir. <br>Lütfen nitelikli bir belge gönderin.',
    goToSubmit: 'Gidin gönderin',
    uncompletedDialog: "MetWallet'ı normal şekilde kullanmak için tamamlamanız gerekir",
    useMetWalletNormallyAfterPassed: "Belge geçtikten sonra MetWallet'ı normal şekilde kullanabilirsiniz.",
    requireSemiVerifiedDialog:
      '{0}, bankanın gereksinimi için, başarılı para çekme işlemi için yarı doğrulanmış bölümü 48 saat içinde tamamlamanız gerekir.',
    goToVerify: 'Gidin doğrulayın',
    emailInvalidDialog:
      '{0}, e-posta adresiniz başka bir kişininkiyle aynıdır. Gizlilik sigortası için lütfen en kısa sürede kendi e-posta adresinizi girin.',
    later: 'Daha sonra',
    transferRequireSemiVerifiedDialog: 'Lütfen transferden önce Yarı Doğrulanmış doğrulamayı tamamlayın.',
    modifyBtnText: 'Bilgilerimi Düzenle',
    unmodifiedTitle: 'Değiştirilemez',
    unmodifiedContent: 'İşlemde bir para çekme siparişiniz var. Bilgiler şu anda değiştirilemez.'
  },
  signing: {
    signature: 'İmza',
    date: 'Tarih',
    employeeName: 'Çalışan Adı',
    designation: 'Unvanı',
    month: 'Ay',
    year: 'Yıl',
    earnings: 'Kazançlar',
    deductions: 'Kesintiler',
    basic: 'Temel ve DA(USD)',
    totalAddition: 'Toplam Ekleme',
    totalDeduction: 'Toplam Kesinti',
    salary: 'NET Maaş',
    refNo: 'Ref No',
    paymentTransferDate: 'Ödeme Transfer Tarihi',
    nameOfBank: 'Banka Adı',
    signatureOfEmployee: 'Çalışanın İmzası',
    director: 'Yönetici',
    signNote: 'Lütfen adınızı imzalayın',
    preview: 'Önizleme',
    clear: 'Temizle',
    save: 'Kaydet',
    noSignatureToast: 'İmza olmadan kaydedemezsiniz.',
    fieldEmptyToast: 'Lütfen tüm bilgileri doldurun.'
  },
  transactionDetail: {
    title: 'İşlem Ayrıntısı',
    status: 'Durum',
    pending: 'Beklemede',
    completed: 'Tamamlandı',
    success: 'BAŞARILI',
    failed: 'Başarısız',
    cancelled: 'İptal edildi',
    onHold: 'Beklemede',
    reason: 'Durum Nedeni',
    description: 'Açıklama',
    creationDate: 'Oluşturma tarihi',
    lastStatusDate: 'Son durum tarihi',
    requestedAmount: 'İstenen tutar',
    receiveAmount: 'Alınan tutar',
    transferAmount: 'Transfer tutarı',
    amountToPay: 'Ödenecek tutar',
    transferFee: 'Transfer ücreti',
    processingFee: 'İşleme ücreti',
    method: 'Yöntem',
    country: 'Ülke',
    name: 'Ad',
    bankPendingText: 'Nihai banka incelemesi altında',
    pendingText: '{0} incelemesi altında',
    chametSalary: 'Chamet maaşı',
    userSalary: 'Kullanıcı maaşı',
    comm: 'İletişim',
    gemgalaSalary: 'Gemgala maaşı'
  },
  transfer: {
    title: 'MetWallet Hesabına',
    noPayPwdDialog: 'Lütfen transferden önce 6 haneli bir ödeme şifresi belirleyin.',
    records: 'Kayıtlar',
    cashInOut: 'Nakit Giriş {0}, Nakit Çıkış {1}',
    transfer: 'Transfer',
    fee: 'Ücret',
    remark: 'Açıklama',
    transferTo: '{0} adresine transfer edin',
    remarkPlaceholder: 'Transfer açıklaması ekleyin (100 karakterden az)',
    firstNameNote: 'Lütfen adını girin',
    sendingAmount: 'Gönderilen Tutar',
    receivingAmount: 'Alınan Tutar',
    transferNow: 'Şimdi Transfer Et',
    noBalanceToast: 'Transfer tutarı bakiye tutarından büyük.',
    amountTooLittleToast: "Transfer tutarı 10$'dan az olamaz."
  },
  bankData: {
    beneficiaryName: 'Yararlanıcı Adı',
    beneficiaryNamePlaceholder: 'Adı Girin',
    beneficiaryLastname: 'Yararlanıcı Soyadı',
    beneficiaryLastnamePlaceholder: 'Soyadı Girin',
    bankCode: 'Banka Kodu',
    bankCodePlaceholder: 'Banka Kodunu Seçin',
    bankIFSCCode: 'Banka IFSC Kodu',
    bankIFSCCodePlaceholder: "Banka IFSC'sini Girin",
    bankAccount: 'Banka Hesabı',
    bankAccountPlaceholder: 'Banka Hesabını Girin',
    email: 'E-posta',
    emailPlaceholder: 'E-posta Girin',
    phoneNumber: 'Telefon Numarası',
    phoneNumberPlaceholder: 'Telefon Numarası Girin',
    address: 'Adres',
    addressPlaceholder: 'Adresi Girin',
    city: 'Şehir',
    cityPlaceholder: 'Şehir Girin',
    state: 'Eyalet',
    statePlaceholder: 'Eyalet Girin',
    postCode: 'Posta Kodu',
    postCodePlaceholder: 'Posta Kodunu Girin',
    documentId: 'Belge Kimliği',
    documentIdPlaceholder: 'Belge Kimliğini Girin',
    nationalId: 'National ID',
    nationalIdPlaceholder: 'Enter National ID',
    individualTaxId: 'Individual Tax ID',
    individualTaxIdPlaceholder: 'Enter Individual Tax ID',
    documentType: 'Belge Türü',
    documentTypePlaceholder: 'Belge Türünü Seçin',
    accountType: 'Hesap Türü',
    accountTypePlaceholder: 'Hesap Türünü Seçin',
    cpfcnpjPlaceholder: 'CPFCNPJ Girin',
    bankBranch: 'Banka Şubesi',
    bankBranchPlaceholder: 'Banka Şubesini Girin',
    ribOfBankAccount: "Banka Hesabı RIB'si",
    bankName: 'Banka Adı',
    bankNamePlaceholder: 'Banka Adını Girin',
    bicCode: 'BIC kodu',
    bicCodePlaceholder: 'BIC kodunu girin',
    ibanPlaceholder: 'IBAN Girin',
    bankSwift: 'Banka Swift',
    bankSwiftPlaceholder: "Banka Swift'ini Girin",
    name: 'Ad',
    documentCountry: 'Belge Ülkesi',
    documentCountryPlaceholder: 'Belge Ülkesini Seçin',
    issueDate: 'Belge Düzenleme Tarihi',
    issueDatePlaceholder: 'Düzenleme Tarihini Seçin',
    expireDate: 'Belge Son Kullanma Tarihi',
    expireDatePlaceholder: 'Son Kullanma Tarihini Seçin',
    bankBranchName: 'Banka Şubesi Adı',
    bankBranchNamePlaceholder: 'Şube Adını Girin',
    branchPlaceholder: 'Şubeyi Girin',
    gender: 'Cinsiyet',
    genderPlaceholder: 'Cinsiyet Seçin',
    birthday: 'Doğum Günü',
    birthdayPlaceholder: 'Seçin Doğum günü',
    phone: 'Telefon',
    bankAddress: 'Banka Adresi',
    bankAddressPlaceholder: 'Banka Adresini Girin',
    bankAccountName: 'Banka Hesap Adı',
    bankAccountNamePlaceholder: 'Banka Hesap Adını Girin',
    province: 'İl',
    provincePlaceholder: 'İl Girin',
    postalCode: 'Posta Kodu',
    postalCodePlaceholder: 'Posta Kodunu Girin',
    savingsAccount: 'Tasarruf Hesabı',
    abaRoutingNumber: 'ABA yönlendirme numarası',
    englandBankAccount: 'England Banka Hesabı',
    bankBranch2: 'bankaŞubesi',
    bankBranch2Placeholder: 'Yalnızca banka Santander ise',
    paternalName: 'Paternal Adı',
    paternalNamePlaceholder: 'Paternal Adını Girin',
    passportIdNumber: 'Pasaport Kimlik Numarası',
    bankNamePlaceholder2: 'Banka Adını Seçin',
    areaCode: 'Alan Kodu',
    phoneNumberNoAreaCode: 'Telefon Numarası (Alan Kodu Yok)',
    idType: 'Kimlik Türü',
    idNo: 'Kimlik Numarası',
    idIssueDate: 'Kimlik Düzenleme Tarihi',
    idExpireDate: 'Kimlik Son Kullanma Tarihi',
    ibanStyleToast: "Lütfen 'SA' ile başlayan ve 24 karakter uzunluğunda bir içerik girin."
  },
  rechargeAndTransfer: {
    transfer_limit_1: "Yalnızca Diamond Sellers'a transfer edebilirsiniz",
    search: 'Arama',
    history: 'Aktarılan kullanıcılar',
    confirm_content: "{0}'ı {1}'e transfer etmek istediğinizden emin misiniz",
    success_content: "{0}, {1}'e transfer edildi",
    purchase: 'Satın al',
    purchase_success: "{0}'ı başarıyla satın aldınız",
    insufficient_balance: 'Yetersiz bakiye',
    purchase_diamond: 'Elmas satın al',
    transfer_limit_2: 'Transfer tutarı 10$ ile 30.000$ arasında olmalıdır',
    no_data: 'Veri yok',
    invalid_number: 'Lütfen geçerli bir sayı girin',
    under_limit: "Transfer tutarı 10$'dan az olmamalıdır",
    over_limit: "Transfer tutarı 30.000$'dan az olmalıdır"
  },
  redesign: {
    emailPlaceholder: 'E-posta adresini gir',
    retrievePwd: 'Şifreyi al',
    resetPwd: 'Şifreyi sıfırla',
    newPwdPlaceholder: 'Yeni şifre gir',
    reenterNewPwdPlaceholder: 'Yeni şifreyi tekrar gir',
    reenterPayPwdPlaceholder: 'Lütfen ödeme şifresini tekrar gir',
    sendToPhone: 'Doğrulama kodu telefonunuza gönderildi',
    sendToWhatsapp: "Doğrulama kodu WhatsApp'ınıza gönderildi",
    sendToEmail: 'Doğrulama kodu e-postanıza gönderildi',
    invalidCode: 'Geçersiz kod',
    userId: 'Kullanıcı kimliği',
    other: 'Diğer',
    transactionRecord: 'İşlem Kaydı',
    bankCardInfo: 'Banka kartı hesabı',
    withdrawInfo: 'Çekim hesabı',
    toFillIn: 'Doldurulacak',
    walletInfo: 'Cüzdan hesap bilgileri',
    toComplete: 'Doldurulacak',
    verifyGuide: 'Daha fazla para çekme yeterliliği elde etmek için cüzdan hesap bilgilerini doldurun',
    verifyNote: 'Günlük para çekme yeterliliği elde etmek için aşağıdaki bilgileri doldurun {0}',
    verifyCompletedNote: 'Günlük para çekme yeterliliği elde etmek için bilgiler tamamlandı {0}',
    continueBtnText: 'Doldurmaya devam edin',
    submitInfo: 'Bilgi gönder',
    transferAmount: 'Transfer tutarı',
    newEmailVerify: 'Yeni E-posta doğrulaması',
    verifyCodePlaceholder: 'Doğrulama kodunu gir',
    emailIncorrectToast: 'Lütfen doğru e-posta adresini gir',
    newPhone: 'Yeni telefon numarası',
    accountAdded: 'Hesap bilgileri eklendi',
    accountToAdd: 'Diğer hesaplar eklenebilir',
    edit: 'Düzenle',
    enterPayPwd: 'Ödeme şifresini gir',
    deleteBtnText: 'Sil',
    transferTo: 'Transfer',
    withdrawable: 'Çekilebilir',
    goSet: 'Git ayarla',
    goModify: 'Git değiştir'
  }
}



// WEBPACK FOOTER //
// ./src/configs/language/lang/tr.js